import { useMutation, useQuery } from 'urql';
import { graphql } from '../../gql';
import { MailTemplate } from '../../gql/graphql.ts';
import { MailTemplateEditor } from './MailTemplateEditor.tsx';

interface MailSettingsPageProps {
  companyId: string;
}

const MailSettingsParticipantTemplateQuery = graphql(/* GraphQL */ `
  query mailSettingsParticipantTemplateQuery($companyId: String!) {
    company(companyId: $companyId) {
      mailSettings {
        templateParticipantMail {
          subject
          template
        }
      }
    }
  }
`);

const UpdateParticipantTemplateQuery = graphql(/* GraphQL */ `
  mutation updateParticipantTemplateQuery(
    $companyId: String!
    $company: UpdateCompanyDto!
  ) {
    updateCompany(companyId: $companyId, company: $company) {
      mailSettings {
        templateParticipantMail {
          subject
          template
        }
      }
    }
  }
`);

export const SignUpConfirmationTemplateEditor: React.FC<
  MailSettingsPageProps
> = ({ companyId }) => {
  // TODO: Error handling
  const [{ data }, reExecuteQuery] = useQuery({
    query: MailSettingsParticipantTemplateQuery,
    variables: { companyId },
    pause: companyId === undefined || companyId === null,
  });

  const [, updateCompany] = useMutation(UpdateParticipantTemplateQuery);

  const onFormSubmit = (values: MailTemplate) => {
    updateCompany({
      companyId,
      company: { mailSettings: { templateParticipantMail: values } },
    }).then(() => {
      // TODO: Check for errors and indicate success/failure to UI
      reExecuteQuery();
    });
  };

  return (
    <>
      {data?.company.mailSettings.templateParticipantMail && (
        <MailTemplateEditor
          templateName="Bestätigungsmail Seminaranmeldung"
          companyId={companyId}
          template={data.company.mailSettings.templateParticipantMail}
          onSubmit={onFormSubmit}
        />
      )}
    </>
  );
};
